// src/AvailableCars.jsx
import { useMemo, useState } from 'react';
import useCars from './data/useCars';

const TURO_PROFILE = 'https://turo.com/us/en/drivers/33571187';

export default function AvailableCars() {
  const cars = useCars();
  const [filter, setFilter] = useState('All');

  const tags = useMemo(() => ['All', ...Array.from(new Set(cars.map((c) => c.tag).filter(Boolean)))], [cars]);
  const shown = filter === 'All' ? cars : cars.filter((c) => c.tag === filter);

  return (
    <div className="container-x section-y">
      <div className="flex flex-col gap-4 sm:flex-row sm:items-end sm:justify-between">
        <div>
          <h1 className="display text-4xl sm:text-5xl">Available cars</h1>
          <p className="muted mt-3 max-w-xl">
            Every car is booked through Turo. Tap a car to see its availability and pricing.
          </p>
        </div>
        <a className="btn btn-ghost shrink-0" href={TURO_PROFILE} target="_blank" rel="noopener noreferrer">
          All listings on Turo
        </a>
      </div>

      <div className="-mx-4 mt-8 overflow-x-auto px-4 pb-2 sm:mx-0 sm:px-0" role="group" aria-label="Filter by type">
        <div className="flex gap-2 whitespace-nowrap">
          {tags.map((tag) => {
            const active = tag === filter;
            return (
              <button
                key={tag}
                type="button"
                onClick={() => setFilter(tag)}
                aria-pressed={active}
                className="inline-flex min-h-[2.5rem] items-center rounded-full px-4 text-sm font-medium transition-colors"
                style={{
                  border: `1px solid ${active ? 'var(--bronze)' : 'var(--line)'}`,
                  background: active ? 'var(--bronze)' : 'transparent',
                  color: active ? 'var(--paper-ink)' : 'var(--ink)',
                }}
              >
                {tag}
              </button>
            );
          })}
        </div>
      </div>

      <ul className="mt-8 grid gap-x-6 gap-y-10 sm:grid-cols-2 lg:grid-cols-3">
        {shown.map((car) => (
          <li key={car.id}>
            <a href={car.link} target="_blank" rel="noopener noreferrer" className="group block">
              <div className="aspect-[4/3] overflow-hidden rounded-xl" style={{ background: 'var(--surface)' }}>
                <img
                  src={car.image}
                  alt={car.name}
                  loading="lazy"
                  decoding="async"
                  className="h-full w-full object-cover object-center transition-transform duration-500 group-hover:scale-[1.03]"
                />
              </div>
              <div className="mt-3 flex items-baseline justify-between gap-3">
                <h2 className="display text-xl">{car.name}</h2>
                <span className="muted shrink-0 text-sm">{car.tag}</span>
              </div>
              <p className="link-quiet mt-1 inline-block text-sm">Book on Turo</p>
            </a>
          </li>
        ))}
      </ul>

      {shown.length === 0 && <p className="muted mt-10">No cars match that filter right now.</p>}
    </div>
  );
}
